import React from 'react';
import { Col } from 'react-bootstrap';
import styles from './LoadingItem.css';

export class LoadingItem extends React.Component {
  render() {
    const { element } = this.props;

    return (
      <Col md={6} key={element.key} className={styles['loading-item']}>
        {element.done ? (
          <span
            id={`loading-icon-${element.key}`}
            className={`fa fa-check-circle fa-lg ${styles.done} ${styles.icon}`}
          />
        ) : (
          <span
            id={`loading-icon-${element.key}`}
            className={`fa fa-spinner fa-pulse fa-lg ${
              element.loading ? styles['in-progress'] : ''
            } ${styles.icon}`}
          />
        )}

        <span className={styles['radio-lbl']}>{element.name}</span>
      </Col>
    );
  }
}

export default LoadingItem;
